import { all } from "redux-saga/effects";

import { processNotifications } from "./notifications";
import { processMessages } from "./messages";
import { processAdminActions } from "./admin";
import { processAuthorProfile } from "./author-profile";

export function* rootSaga() {
  // console.log("root saga run pushing notif");
  yield all([
    processNotifications(),
    processMessages(),
    processAdminActions(),
    processAuthorProfile(),
  ]);
}
